export default __webpack_public_path__ + "static/contact-301b2a8492ae568c0b2923a3f7176c62.svg";